import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { RawLocation } from "vue-router/types/router";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import type { RmpTextType, RmpTextSize } from "@rmp/core/components/typography/types";

interface Props {
	to?: RawLocation;
	href?: string;
	text?: string;
	color?: string;
	type?: RmpTextType;
	size?: RmpTextSize;
	weight?: number;
	icon?: string;
	icoSize?: string;
	icoMargin?: string;
	underline?: boolean;
	inline?: boolean;
	blank?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpLink',
  props: {
    to: { default: undefined },
    href: { default: undefined },
    text: { default: undefined },
    color: { default: undefined },
    type: { default: "body" },
    size: { default: "medium" },
    weight: null,
    icon: { default: undefined },
    icoSize: { default: undefined },
    icoMargin: { default: "mr-2" },
    underline: { type: Boolean },
    inline: { type: Boolean },
    blank: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
	(e: "click", event: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { to: RawLocation, href: string, text: string, color: string, type: RmpTextType, size: RmpTextSize, weight?: number, icon: string, icoSize: string, icoMargin: string, underline?: boolean, inline?: boolean, blank?: boolean };





const router = useRouter();

const resolvedHref = computed(() => props.to ? router.resolve(props.to).href : props.href);

const handleClick = (event: MouseEvent) => {
	emit("click", event);
	
	if(!props.to || props.blank || event.defaultPrevented) return;
	
	event.preventDefault();
	router.push(props.to);
};

return { __sfc: true,props, emit, router, resolvedHref, handleClick, RmpIcon, RmpText }
}

})